import { useCallback } from 'react';
import useAgentData from '~/client/hooks/useAgentData';
import useIsLoggedIn from '~/client/hooks/user/useIsLoggedIn';
import useGameClapps from '../useClappsToggle/useGameClapps';

type Props = {
  showTooltip: (messageId: string) => void;
};

const useToggle = ({ showTooltip }: Props) => {
  const { isDesktop } = useAgentData();
  const isLoggedIn = useIsLoggedIn();
  const { isLiked, allClapps, toggleClapp, loading } = useGameClapps();
  const handleClick = useCallback(async () => {
    if (loading || !isLoggedIn) {
      return;
    }

    try {
      const { success } = await toggleClapp();

      if (!success) {
        showTooltip('casino.make_a_bet_to_rate');
      }
    } catch (error) {
      showTooltip('casino.there_were_errors');
    }
  }, [isLoggedIn, toggleClapp, loading, showTooltip]);

  const total = allClapps?.clapps;
  return {
    isDesktop,
    total,
    isLiked,
    handleClick,
  };
};

export default useToggle;
